let id = 1;

export default function () {
    return '__ID_' + (id++)
}
